<ng-container *transloco="let t; read: 'admin'">
  <div appScrollTo class="container mat-elevation-z2 widget-background">
    <a routerLink="bookings/all">{{ t("page_bookings") }}</a>
  </div>
</ng-container>
